export default "__VITE_ASSET__thndEsY7__"